import { useEffect, useState } from 'react';
import { decodeBase64 } from '../common';
import { decryptData } from '@/components/reusable/crypto/Cipher';

// utils/permissions.js

/**
 * Fetches permissions from session storage or another source.
 * @returns {Array} - Array of permissions.
 */
export const fetchPermissions = () => {
  const permissions = decryptData(localStorage.getItem('menuData')) || [];
  return permissions;
};

export const fetchAdminPermissions = () => {
  const permissions = decryptData(localStorage.getItem('__adminMenu__')) || [];
  return permissions;
};

export const usePermission = () => {
  const [permissions, setPermission] = useState([]);
  const [isAdmin, setAdmin] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    (async function () {
      try {
        setLoading(true);
        const data = await decryptData(localStorage.getItem('__adminMenu__'));
        setPermission(data);
      } catch (error) {
        setError(error);
        throw new Error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    (async function () {
      try {
        const data = localStorage.getItem('_user_');
        let decodedData = decodeBase64(data);
        setAdmin(decodedData.isAdmin);
      } catch (error) {
        throw new Error(error);
      }
    })();
  }, []);

  return { permissions, isLoading, isAdmin, error };
};
/**
 * Checks if the user has permission to perform a certain action.
 * @param {Array} permissions - Array of permissions.
 * @param {string} name - The name of the permission set (e.g., 'Ledger').
 * @param {string} action - The action to check (e.g., 'isUpdate', 'isDelete').
 * @returns {boolean} - True if the user has the permission, false otherwise.
 */
export const hasPermission = (permissions, name, action) => {
  const findPermission = (permissionsArray, targetName) => {
    for (let i = 0; i < permissionsArray?.length; i++) {
      const perm = permissionsArray[i];
      if (perm.name === targetName) {
        return perm;
      }
      if (perm?.subMenus && perm.subMenus?.length > 0) {
        const foundInSubmenu = findPermission(perm?.subMenus, targetName);
        if (foundInSubmenu) {
          return foundInSubmenu;
        }
      }
    }
    return null;
  };
  const permissionSet = findPermission(permissions, name);
  const result = permissionSet ? permissionSet[action] : false;

  return result;
};
